const channelTypes = {
    CONSUMER: 'CONSUMER',
    RETAIL: 'RETAIL',
};

export default channelTypes;
